import { useState, type CSSProperties } from 'react';
import {
  COMBAT_ICON_FALLBACK,
  combatIconSource,
  type CombatIconId,
} from '@/domain/combat/combat-icons';

interface Props {
  id: CombatIconId;
  size?: number;
  label: string;
  style?: CSSProperties;
}

export function CombatIcon({ id, size = 24, label, style }: Props) {
  const [source, setSource] = useState(() => combatIconSource(id));
  return (
    <img
      src={source}
      alt={label}
      width={size}
      height={size}
      onError={() => setSource(COMBAT_ICON_FALLBACK)}
      style={{ width: size, height: size, objectFit: 'contain', imageRendering: 'pixelated', ...style }}
    />
  );
}
